module.exports = __webpack_public_path__ + "media/images/footer_contact_others-cfc9340bae855f5c29452eed9cbc136b.svg";